import { useContext } from "react";
import type { Instance } from "mobx-state-tree";
import { types } from "mobx-state-tree";
import { AppContext } from "util/react-utils";

import { StreamsStore } from "pages/index/state/store/stream/streams-store";
import { CampaignsStore } from "pages/index/state/store/campaign/campaigns-store";
import { OrganizationStore } from "pages/organization/state/store/organization-store";

import { UserStore } from "../user/user-store";
import { UsersStore } from "../user/users-store";

export const AppStore = types
    .model(`App`, {
        user: types.maybe(UserStore),
        streams: types.maybe(StreamsStore),
        campaigns: types.maybe(CampaignsStore),
        users: types.maybe(UsersStore),
        organization: types.maybe(OrganizationStore),
        organizationId: types.maybe(types.string)
    })
    .actions((self) => ({
        setOrganizationId(organizationId) {
            self.organizationId = organizationId;
        },
        setUser(user: Instance<typeof UserStore>) {
            self.user = user;
        },
        setStreams(streams: Instance<typeof StreamsStore>) {
            self.streams = streams;
        },
        setCampaigns(campaigns: Instance<typeof CampaignsStore>) {
            self.campaigns = campaigns;
        },
        setUsers(users: Instance<typeof UsersStore>) {
            self.users = users;
        },
        setOrganization(organization: Instance<typeof OrganizationStore>) {
            self.organization = organization;
        }
    }));

export const useAppStore = () => {
    const { appStore } = useContext(AppContext) as {
        appStore: AppStoreInstance;
    };
    return appStore;
};

export interface AppStoreInstance extends Instance<typeof AppStore> {}
